import React, { useCallback, useMemo, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';
import CreateIcon from '@mui/icons-material/Create';

import SpeedDialMenu from '@ts-core/components/SpeedDialMenu';
import { useCourseContext } from '@ts-core/context/course';

import { useCourses, useCourseActions } from '../../hooks';
import CoursesList, { useCoursesList } from '../../components/CoursesList';

const CoursesPage = () => {
  const history = useHistory();
  const { courses, loading: loadingCourses } = useCourses();
  const { onRemoveCourse } = useCourseActions();
  const { setCourse } = useCourseContext();

  useEffect(() => {
    setCourse();
  }, [setCourse]);

  const onEditCourse = useCallback(
    (course) => {
      history.push(`/courses/${course._id}/edit`);
    },
    [history]
  );

  const onSelectCourse = useCallback(
    (course) => {
      history.push(`/${course._id}/dashboard`);
    },
    [history]
  );

  const onAddCourse = useCallback(() => {
    history.push('/courses/new');
  }, [history]);

  const courseListProps = useCoursesList({
    courses,
    loading: loadingCourses,
    onSelectCourse,
    onEditCourse,
    onRemoveCourse,
    onAddCourse,
  });

  const speedDialOptions = useMemo(
    () => [
      {
        title: <FormattedMessage id="button.addCourse.title" />,
        icon: <CreateIcon />,
        onClick: onAddCourse,
      },
    ],
    [onAddCourse]
  );

  return (
    <>
      <Box pb={5}>
        <CoursesList {...courseListProps} />
      </Box>
      <SpeedDialMenu options={speedDialOptions} />
    </>
  );
};

CoursesPage.propTypes = {};

export default CoursesPage;
